import PropTypes from 'prop-types';
import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import Avatar, { AvatarSizes } from '../avatar';

const ActivityFeedItem = ({
  feedItem: {
    firstName, lastName, image, activity, status, datetime,
  },
}) => (
  <>
    <div className="activity-feed-item">
      <Avatar
        size={AvatarSizes.MEDIUM}
        firstName={firstName}
        lastName={lastName}
        image={image}
        description={activity}
        status={status}
      />
      <span className="time">
        {formatDistanceToNow(new Date(datetime), { includeSeconds: true })}
      </span>
    </div>
    <hr className="separator" />
  </>
);

ActivityFeedItem.propTypes = {
  feedItem: PropTypes.shape({
    activity: PropTypes.string,
    firstName: PropTypes.string,
    image: PropTypes.string,
    lastName: PropTypes.string,
    status: PropTypes.string,
    datetime: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]),
  }).isRequired,

};

export default ActivityFeedItem;
